module.exports = __webpack_public_path__ + "img/instructor_img8.eb9fd0fe.png";